import React, { useEffect } from 'react';
import { Pie, G2, measureTextWidth } from '@ant-design/plots';
import "@ant-design/flowchart/dist/index.css"
import NoData from '../../custom-components/NoData';

export const GrtCircularGraph = (props) => {
  const G = G2.getEngine('canvas');
  // const ref = useRef();
  function renderStatistic(containerWidth, text, style) {
    const { width: textWidth, height: textHeight } = measureTextWidth(text, style);
    const R = containerWidth / 2; // r^2 = (w / 2)^2 + (h - offsetY)^2

    let scale = 1;

    if (containerWidth < textWidth) {
      scale = Math.min(Math.sqrt(Math.abs(Math.pow(R, 2) / (Math.pow(textWidth / 2, 2) + Math.pow(textHeight, 2)))), 1);
    }

    const textStyleStr = `width:${containerWidth}px;`;
    return `<div style="${textStyleStr};font-size:${style.fontSize}px;color:${style.color};line-height:${scale < 1 ? 1 : 'inherit'};">${text}</div>`;
  }
  const {
    innerFirstLineTextFontSize,
    innerFirstLineTextColor,
    innerFirstLineText,
    innerSecondLineTextFontSize,
    innerSecondLineTextColor,
    innerSecondLineText,
    data,
    setColor,
    setLabel,
    innerRadius,
    isShowNav,
    navArrangement,
    navPosition,
    padding,
    isShowTooltip,
    tooltipTypeLabel,
    tooltipValueLabel,
    isUseSpiderLayout,
    legendOffsetX,
    legendOffsetY,
    titleY,
    subTitleY
  } = props;

  const config = {

    padding,
    autoFit: true,
    height: '100%',
    data,
    angleField: 'value',
    colorField: 'type',
    color: setColor ? setColor : ['#5B8FF9', '#61DDAA', '#65789B', '#F6BD16', '#7262FD', '#78D3F8', '#9661BC', '#F6903D', '#008685', '#F08BB4'],
    radius: 1,
    innerRadius,
    legend: isShowNav ? {
      layout: navArrangement,//vertical,
      position: navPosition,
      offsetX: legendOffsetX,
      offsetY: legendOffsetY,
    } : isShowNav,

    label: isUseSpiderLayout ? {
      type: 'spider',
      formatter: (data) => {
        const group = new G.Group({});
        group.addShape({
          type: 'text',
          attrs: {
            x: 10,
            y: 8,
            text: `${data.type}`,
            // fill: mappingData.color,
            fill: '#1e1f1c',
          },
        });
        return group;
      }
    } : {
      type: 'inner',
      offset: '50%',
      autoRotate: false,
      content: ({ percent }) => `${(percent * 100).toFixed(0)}%`,
    },

    statistic: {
      title: {
        offsetY: titleY,
        customHtml: (container, view, datum) => {
          const { width, height } = container.getBoundingClientRect();
          const d = Math.sqrt(Math.pow(width / 2, 2) + Math.pow(height / 2, 2));
          const text = datum ? datum.type : (innerFirstLineText ? innerFirstLineText : '总人数');
          return renderStatistic(d, text, {
            fontSize: innerFirstLineTextFontSize,
            color: innerFirstLineTextColor
          });
        },
      },
      content: {
        offsetY: subTitleY,
        style: {
          fontSize: '32px',
        },
        customHtml: (container, view, datum, data) => {
          const { width } = container.getBoundingClientRect();
          const text = datum ? `${datum.value}` : `${data.reduce((r, d) => r + d.value, 0)}${innerSecondLineText ? innerSecondLineText : '人'}`;
          return renderStatistic(width, text, {
            fontSize: innerSecondLineTextFontSize,
            color: innerSecondLineTextColor
          });
        },
      },
    },

    tooltip: isShowTooltip ? {
      fields: ['type', 'value'],
    } : null,
    meta: {
      type: {
        alias: tooltipTypeLabel
      },
      value: {
        alias: tooltipValueLabel
      }
    },
    // 添加 中心统计文本 交互
    interactions: innerRadius ? [
      {
        type: 'element-active',
      },
      {
        type: 'pie-statistic-active',
      },
    ] : null,
  }

  // useEffect(() => {
  //   setTimeout(() => {
  //     const chart = ref.current.getChart();
  //     // chart.chart.interaction('element-selected', {
  //     //   start: [{
  //     //     trigger: 'element:mouseenter',
  //     //     action: 'element-selected:toggle'
  //     //   }],
  //     //   // start: [{ trigger: 'element:mouseenter', action: 'element-single-selected:active' }],
  //     //   end: [{ trigger: 'element:mouseleave', action: 'element-selected:reset' }],
  //     // })
  //     console.log(chart)

  //     chart.chart.interaction('element-selected', {
  //       start: [{
  //         trigger: 'element:mouseenter',
  //         action: ['element-selected:selected']
  //       }
  //       ],
  //       end: [{ trigger: 'element:mouseleave', action: 'element-selected:reset' }],
  //     })
  //   }, 300)

  // }, [])
  // console.log(333)
  return <>
    {data && data.length > 0 ? <Pie   {...config} /> : <NoData />}
  </>
}
